import Swiper, {Navigation, Pagination} from "swiper";
Swiper.use([Navigation, Pagination]);

const initCasesSlider = () => {
  const sliderContainer = document.querySelector("[data-cases-slider]");
  sliderContainer && new Swiper(sliderContainer, {
    spaceBetween: 16,
    breakpoints: {
      997: {
      slidesPerView: 3,
      },    
      768: {
        slidesPerView: 2,
      },       
      0: {
        slidesPerView: 1,
      },
    },
    pagination: {
      el: "[data-cases-slider-container] .swiper-pagination",
      clickable: true,
      bulletElement: "button",
    },
    navigation: {
      nextEl: "[data-cases-slider-container] .slider-navigation__button--next",
      prevEl: "[data-cases-slider-container] .slider-navigation__button--prev",
    },
  });  
};

export default initCasesSlider;
